import "../../../../styles/workspace_styles/SystemAdministratorStyles/TenantAdministrators/NewTenantAdministrator.css";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppProvider";
import { TenantAdministratorContext } from "./TenantAdministratorProvider";
import countries from "../../../../functions/getCountries";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";

const NewTenantAdministrator = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        showCreateNewTenantAdministratorWindow,
        setShowCreateNewTenantAdministratorWindow,
        setReloadTenantAdministrators
    } = useContext(TenantAdministratorContext);
    const [createTenantAdministratorStatus,setCreateTenantAdministratorStatus] = useState('');
    const [countryFilterString,setCountryFilterString] = useState('');
    const [showCountriesBrowser,setShowCountriesBrowser] = useState(false);

    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [emailAddress,setEmailAddress] = useState('');
    const [password,setPassword] = useState('');
    const [selectedCountry,setSelectedCountry] = useState(null);
    const [city,setCity] = useState('');
    const [phoneNumber,setPhoneNumber] = useState('');
    const [postalCode,setPostalCode] = useState('');
    const [address,setAddress] = useState('');
    const [address2,setAddress2] = useState('');
    const createTenantAdministrator = async() =>{
        setCreateTenantAdministratorStatus('creating');
        try{
            const newTenantAdministratorPayload = {
                firstName:firstName,
                lastName:lastName,
                emailAddress:emailAddress,
                password:password,
                country:selectedCountry,
                city:city,
                phoneNumber:phoneNumber,
                postalCode:postalCode,
                address:address,
                address2:address2
            }
            const url = `${usersMicroserviceUrl}/system-admins/tenants`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                },
                body:JSON.stringify(newTenantAdministratorPayload)
            });
            if(response.ok){
                setCreateTenantAdministratorStatus('created');
                return;
            }
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('An error occurred when creating tenant administrator',error);
        }
        setCreateTenantAdministratorStatus('create-error');
    };
    const clearEntries = () =>{
        setFirstName('');
        setLastName('');
        setEmailAddress('');
        setPassword('');
        setSelectedCountry(null);
        setCity('');
        setPhoneNumber('');
        setPostalCode('');
        setAddress('');
        setAddress2('');
    };
    const disposeWindow = () =>{
        clearEntries();
        setCreateTenantAdministratorStatus('');
        setShowCreateNewTenantAdministratorWindow(false);
    };
    const validFormToolTipText = () =>{
        if(firstName === '') return 'Enter the first name to proceed';
        if(lastName === '') return 'Enter the last name to proceed';
        if(emailAddress === '') return 'Enter a valid email address to proceed';
        if(password === '') return 'Enter a valid password to proceed';
        if(selectedCountry === '') return "Select the user's country to proceed";
        if(city === '') return "Enter city name to proceed";
        return '';
    };
    useEffect(() =>{
        const handleEsc = (e) =>{
            if(e.key === 'Escape' && createTenantAdministratorStatus !== 'creating' && createTenantAdministratorStatus !== '') disposeWindow();
        };
        document.addEventListener('keydown',handleEsc);
        return () =>{
            document.removeEventListener('keydown',handleEsc);
        };
    },[showCreateNewTenantAdministratorWindow,createTenantAdministratorStatus]);
    useEffect(() =>{
        if(showCreateNewTenantAdministratorWindow) document.title = 'Blink IOT | New Tenant Admin';
        else document.title = 'Blink IOT | Tenant Administrators';
    },[showCreateNewTenantAdministratorWindow]);
    useEffect(() => {
        if(createTenantAdministratorStatus === 'created') setReloadTenantAdministrators(true);
    },[createTenantAdministratorStatus]);
    if(!showCreateNewTenantAdministratorWindow) return null;
    return(
        <div className="system-administrator-new-tenant-administrator-parent-container">
            {createTenantAdministratorStatus ===''?
                (
                    <div className="system-administrator-new-tenant-administrator-container">
                        <div className="system-administrator-new-tenant-administrator-header">
                            <h1>Add tenant administrator</h1>
                            <p onClick={() => disposeWindow()}>&#10006;</p>
                        </div>
                        <div className="system-administrator-new-tenant-administrator-body">
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>First Name<span>*</span></p>
                                <input
                                    placeholder="Enter first name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Last Name<span>*</span></p>
                                <input
                                    placeholder="Enter last name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Email Address<span>*</span></p>
                                <input
                                    placeholder="Enter email address"
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Password<span>*</span></p>
                                <input
                                    placeholder="Enter password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Country<span>*</span></p>
                                {selectedCountry?
                                    (
                                        <div className="system-administrator-new-tenant-administrator-selected-country-display">
                                            <p>{selectedCountry}</p>
                                            <p className="cancel-p" onClick={() => setSelectedCountry(null)}>&#10006;</p>
                                        </div>
                                    ):
                                    (
                                        <input
                                            placeholder="Select country"
                                            value={countryFilterString}
                                            onChange={(e) => setCountryFilterString(e.target.value)}
                                            onFocus={() => setShowCountriesBrowser(true)}
                                            onBlur={() => setTimeout(() =>{setShowCountriesBrowser(false)},150)}
                                        />
                                    )
                                }
                                <div className={`system-administrator-new-tenant-administrator-countries-browser ${showCountriesBrowser? 'active':''}`}>
                                    {[...countries].filter(country => country.toLowerCase().includes(countryFilterString?.toLowerCase())).
                                        sort((a,b) => a.localeCompare(b)).map((country) =>(
                                        <div key={country} onClick={() =>{
                                            setSelectedCountry(country);
                                            setCountryFilterString('');
                                        }}>
                                            {country}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>City<span>*</span></p>
                                <input
                                    placeholder="Enter city"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Phone Number</p>
                                <input
                                    placeholder="Enter phone number"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Postal Code</p>
                                <input
                                    placeholder="Enter postal code"
                                    value={postalCode}
                                    onChange={(e) => setPostalCode(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Address</p>
                                <input
                                    placeholder="Enter address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </div>
                            <div className="system-administrator-new-tenant-administrator-entry-container">
                                <p>Address 2</p>
                                <input
                                    placeholder="Enter address 2"
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="system-administrator-new-tenant-administrator-buttons-container">
                            <button className="cancel" onClick={() => disposeWindow()}>Cancel</button>
                            <button
                                className={`add ${validFormToolTipText() === ''? 'active':'inactive'}`}
                                title={validFormToolTipText()}
                                onClick={() => {
                                    if(validFormToolTipText() !== '') return;
                                    createTenantAdministrator();
                                }}>Create</button>
                        </div>
                    </div>
                ):createTenantAdministratorStatus === 'creating'?
                (
                    <div className="system-administrator-new-tenant-administrator-creating-container">
                        <div></div>
                        <p>Creating tenant administrator. Please wait...</p>
                    </div>
                ):createTenantAdministratorStatus === 'created'?
                (
                    <div className="system-administrator-new-tenant-administrator-created-container">
                        <div className="system-administrator-new-tenant-administrator-created-details-container">
                            <p>Tenant administrator created successfully</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="system-administrator-new-tenant-administrator-created-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):createTenantAdministratorStatus === 'create-error'?
                (
                    <div className="system-administrator-new-tenant-administrator-create-error-container">
                        <div className="system-administrator-new-tenant-administrator-create-error-details-container">
                            <p>Unexpected error occurred when creating tenant administrator</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="system-administrator-new-tenant-administrator-create-error-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <></>
                )
            }
        </div>
    );
};
export default NewTenantAdministrator;